import React, { useMemo } from 'react';
import { Box } from '@mui/material';

interface Props {
  children?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  date?: Date;
}

export const DayColumn2 = React.memo<Props>(({ 
  children, 
  className, 
  style,
  date 
}) => {
  const formattedDate = useMemo(() => {
    if (!date) return '';
    return new Intl.DateTimeFormat('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    }).format(date);
  }, [date]);

  return (
    <Box
      className={className}
      sx={{
        ...style,
        position: 'relative',
        minHeight: '100%',
        display: 'flex',
        flexDirection: 'column',
        bgcolor: 'background.paper'
      }}
      data-date={formattedDate}
      role="gridcell"
      aria-label={date ? formattedDate : undefined}
    >
      {children}
    </Box>
  );
});

DayColumn2.displayName = 'DayColumn2';